export const enum VissErrorCode {
  INVALID_VEHICLE_ID = 'INVALID_VEHICLE_ID',
  INVALID_PRODUCT_CODE = 'INVALID_PRODUCT_CODE',
  INVALID_COMMISSION_NUMBER = 'INVALID_COMMISSION_NUMBER',
  INVALID_CONFIGURATION_ID = 'INVALID_CONFIGURATION_ID',
  INVALID_MARKET_ID = 'INVALID_MARKET_ID',
  INVALID_MODEL_ID = 'INVALID_MODEL_ID',
  INVALID_FINANCIAL_CODE = 'INVALID_FINANCIAL_CODE',
  INVALID_PRODUCT_ID = 'INVALID_PRODUCT_ID',
  INVALID_OUTLET_ID = 'INVALID_OUTLET_ID',
  PRODUCT_CODE_AND_COMMISSION_NUMBER = 'PRODUCT_CODE_AND_COMMISSION_NUMBER',
  NO_PRODUCT_CODE_AND_NO_COMMISSION_NUMBER = 'NO_PRODUCT_CODE_AND_NO_COMMISSION_NUMBER',
  NO_VEHICLE_ID_NO_STOCK_ID = 'NO_VEHICLE_ID_NO_STOCK_ID',
  NO_STOCK_ID_PROVIDED = 'NO_STOCK_ID_PROVIDED',
  CCS_INVALID_VEHICLE = 'CCS_INVALID_VEHICLE',
  CCS_NOT_AVAILABLE = 'CCS_NOT_AVAILABLE',
  CCS_OTHER = 'CCS_OTHER',
  HVD_INVALID_REQUEST = 'HVD_INVALID_REQUEST',
  HVD_NOT_AVAILABLE = 'HVD_NOT_AVAILABLE',
  HVD_OTHER = 'HVD_OTHER',
  IFS_INVALID_REQUEST = 'IFS_INVALID_REQUEST',
  IFS_NOT_AVAILABLE = 'IFS_NOT_AVAILABLE',
  IFS_OTHER = 'IFS_OTHER',
  BBD_INVALID_REQUEST = 'BBD_INVALID_VEHICLE',
  BBD_NOT_AVAILABLE = 'BBD_NOT_AVAILABLE',
  BBD_OTHER = 'BBD_OTHER',
  FORMATTING_SERVICE_INVALID_REQUEST = 'FORMATTING_SERVICE_INVALID_REQUEST',
  FORMATTING_SERVICE_NOT_AVAILABLE = 'FORMATTING_SERVICE_NOT_AVAILABLE',
  FORMATTING_SERVICE_OTHER = 'FORMATTING_SERVICE_OTHER',
  SIM_SEARCH_INVALID_REQUEST = 'SIM_SEARCH_INVALID_REQUEST',
  SIM_SEARCH_NOT_AVAILABLE = 'SIM_SEARCH_NOT_AVAILABLE',
  SIM_SEARCH_FORBIDDEN = 'SIM_SEARCH_FORBIDDEN',
  SIM_SEARCH_VEHICLE_NOT_FOUND = 'SIM_SEARCH_VEHICLE_NOT_FOUND',
  SIM_SEARCH_NO_VEHICLES_FOR_MARKET = 'SIM_SEARCH_NO_VEHICLES_FOR_MARKET',
  SIM_SEARCH_INSUFFICIENT_RESULT_DATA = 'SIM_SEARCH_INSUFFICIENT_RESULT_DATA',
  SIM_SEARCH_OTHER = 'SIM_SEARCH_OTHER',
  VPC_INVALID_REQUEST = 'VPC_INVALID_REQUEST',
  VPC_NOT_AVAILABLE = 'VPC_NOT_AVAILABLE',
  VPC_OTHER = 'VPC_OTHER',
  VPCU_INVALID_REQUEST = 'VPCU_INVALID_REQUEST',
  VPCU_NOT_AVAILABLE = 'VPCU_NOT_AVAILABLE',
  VPCU_OTHER = 'VPCU_OTHER',
  DLS_INVALID_REQUEST = 'DLS_INVALID_REQUEST',
  DLS_NOT_AVAILABLE = 'DLS_NOT_AVAILABLE',
  DLS_OTHER = 'DLS_OTHER',
  ISS_INVALID_REQUEST = 'ISS_INVALID_REQUEST',
  ISS_NOT_AVAILABLE = 'ISS_NOT_AVAILABLE',
  ISS_OTHER = 'ISS_OTHER',
}
